import { render, staticRenderFns } from "./GroupByMachineHeader.vue?vue&type=template&id=97971f1e&scoped=true&"
import script from "./GroupByMachineHeader.vue?vue&type=script&lang=js&"
export * from "./GroupByMachineHeader.vue?vue&type=script&lang=js&"
import style0 from "./GroupByMachineHeader.vue?vue&type=style&index=0&id=97971f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97971f1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
